import {
  NetworkMeasurementType,
  NetworkMeasurementTypeType,
} from "@validereinc/domain";

const adjustmentFactorKey = "adjustment_factor";

function buildNetworkCalculationMeasurementTypeKeysForQuantityBase(
  quantityBase: NetworkMeasurementTypeType
): string[] {
  const upstreamKey = `upstream_${quantityBase}`;

  return [
    upstreamKey,
    `downstream_${quantityBase}_adjustable`,
    `downstream_${quantityBase}_adjusted`,
    `downstream_${quantityBase}_non_adjustable`,
  ];
}

export function getOrderedNetworkCalculationMeasurementTypeKeys(): string[] {
  return [
    adjustmentFactorKey,
    ...buildNetworkCalculationMeasurementTypeKeysForQuantityBase(
      NetworkMeasurementType.volume
    ),
    ...buildNetworkCalculationMeasurementTypeKeysForQuantityBase(
      NetworkMeasurementType.mass
    ),
    ...buildNetworkCalculationMeasurementTypeKeysForQuantityBase(
      NetworkMeasurementType.energy
    ),
  ];
}

export const NetworkCalcsMeasurementTypes =
  getOrderedNetworkCalculationMeasurementTypeKeys();
